// extracted by mini-css-extract-plugin
export default {"logout":"logout_logout__uuiZ2","logoutContainer":"logout_logoutContainer__9CWK2"};